export var TapeBundle = /*#__PURE__*/ function(TapeBundle) {
    TapeBundle[TapeBundle["ALL_ES5"] = 0] = "ALL_ES5";
    TapeBundle[TapeBundle["DEBUG_ES5"] = 1] = "DEBUG_ES5";
    TapeBundle[TapeBundle["DASH_WEBVTT_ES5"] = 2] = "DASH_WEBVTT_ES5";
    TapeBundle[TapeBundle["DASH_WEBVTT_CEA_ES5"] = 3] = "DASH_WEBVTT_CEA_ES5";
    TapeBundle[TapeBundle["HLS_WEBVTT_ES5"] = 4] = "HLS_WEBVTT_ES5";
    TapeBundle[TapeBundle["HLS_WEBVTT_CEA_ES5"] = 5] = "HLS_WEBVTT_CEA_ES5";
    TapeBundle[TapeBundle["ALL_ESNEXT"] = 6] = "ALL_ESNEXT";
    TapeBundle[TapeBundle["DEBUG_ESNEXT"] = 7] = "DEBUG_ESNEXT";
    TapeBundle[TapeBundle["DASH_WEBVTT_ESNEXT"] = 8] = "DASH_WEBVTT_ESNEXT";
    TapeBundle[TapeBundle["DASH_WEBVTT_CEA_ESNEXT"] = 9] = "DASH_WEBVTT_CEA_ESNEXT";
    TapeBundle[TapeBundle["HLS_WEBVTT_ESNEXT"] = 10] = "HLS_WEBVTT_ESNEXT";
    TapeBundle[TapeBundle["HLS_WEBVTT_CEA_ESNEXT"] = 11] = "HLS_WEBVTT_CEA_ESNEXT";
    return TapeBundle;
}({});

//# sourceMappingURL=tape.enums.js.map